<template>
  <div class="homeHeader" :data-type="advCoverType" v-if="advList && advList.length">
    <!-- 小方块布局 -->
    <template v-if="advCoverType === 'small-cube'">
      <div class="firstRow" v-if="firstRowList.length">
        <div class="rectAdvBox" @click="jumpAdv(item)" v-for="item in firstRowList" :key="item.id">
          <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
          <div class="rectName">{{ item.name }}</div>
        </div>
      </div>
      <template v-if="secondRowList.length >= 6">
        <div
          :class="['adv-line-2', 'flex', isStopAnimation ? 'stopAnima' : '']"
          @touchmove.stop="onTouchMove"
          @touchend="onTouchEnd"
          ref="scrollableRef"
          :style="{ '--animation-duration': `${secondRowList.length * 2}s` }"
        >
          <div class="fiveGrid secondLine shrink animation">
            <div class="rectAdvBox" v-for="item in secondRowList" :key="'first-' + item.id" @click="jumpAdv(item)">
              <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
              <div class="rectName">{{ item.name }}</div>
            </div>
          </div>
          <div class="fiveGrid secondLine shrink append animation">
            <div class="rectAdvBox" v-for="item in secondRowList" :key="'second-' + item.id" @click="jumpAdv(item)">
              <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
              <div class="rectName">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="firstRow" v-if="secondRowList && secondRowList.length">
          <div class="rectAdvBox" v-for="item in secondRowList" :key="item.id" @click="jumpAdv(item)">
            <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
            <div class="rectName">{{ item.name }}</div>
          </div>
        </div>
      </template>
    </template>

    <template v-else-if="advCoverType === 'vertical-cube'">
      <div
        :class="['adv-line-2 flex verticalCube', isStopAnimation ? 'stopAnima' : '']"
        @touchmove.stop="onTouchMove"
        @touchend="onTouchEnd"
        ref="scrollableRef"
        :style="{ '--animation-duration': `${advList.length * 3}s` }"
      >
        <div class="fiveGrid secondLine shrink animation">
          <div class="rectAdvBox" v-for="item in advList" :key="'first-' + item.id" @click="jumpAdv(item)">
            <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
            <div class="rectName">{{ item.name }}</div>
          </div>
        </div>
        <div class="fiveGrid secondLine shrink append animation">
          <div class="rectAdvBox" v-for="item in advList" :key="'second-' + item.id" @click="jumpAdv(item)">
            <lazyImg class="rectAdvIcon" :src="item.pictureUrl" />
            <div class="rectName">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </template>
    <!-- 大图轮播 -->
    <template v-else-if="advCoverType.indexOf('banner-') > -1">
      <van-swipe :autoplay="2000" :indicator-color="indicatorColor" class="swipe-box">
        <van-swipe-item v-for="(item, index) in advList" @click="jumpAdv(item)" :key="index">
          <ImgDecypt :src="item.pictureUrl" :key="item.pictureUrl" />
          <div class="title" v-if="showTitle">{{ item.name }}</div>
        </van-swipe-item>
      </van-swipe>
    </template>
  </div>
</template>
<script>
import { getAdItem, AdType } from "@/utils/getAdv.js";
import { jumpAdv } from '@/utils/getAdv';
import ImgDecypt from "@/components/ImgDecypt";
import lazyImg from "@/components/LazyImg/index.vue";

export default {
  name: 'HomeHeader',
  components: {
    ImgDecypt,
    lazyImg,
  },
  props: {
    advType: {
      type: Number,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    indicatorColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      isStopAnimation: false,
      advList: [], // 所有广告
      advCoverType: 'small-cube', // 广告类型 'small-cube' | 'vertical-cube'
      timer: null,
    };
  },
  computed: {
    // 第一行广告
    firstRowList() {
      return this.advList.slice(0, 5);
    },
    // 第二行广告
    secondRowList() {
      return this.advList.slice(5, 20);
    },
  },
  methods: {
    init() {
      let list = [];
      if (this.advType) {
        list = getAdItem(this.advType) || [];
      }
      this.advList = list.slice(0, 20);
      this.advCoverType = list?.[0]?.coverType || list?.[0]?.coverImgSize || 'small-cube';
    },
    onTouchMove() {
      this.isStopAnimation = true;
    },
    onTouchEnd() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.$refs.scrollableRef.scrollLeft = 0;
        this.isStopAnimation = false;
      }, 3000);
    },
    jumpAdv,
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="scss">
.homeHeader {
  --size-width: 60px;
  --size-height: 60px;
  .rectAdvBox {
    width: var(--size-width);
    .rectAdvIcon {
      height: var(--size-height);
      width: var(--size-width);
      border-radius: 10px;
      overflow: hidden;
    }
    .rectName {
      color: #000;
      font-size: 12px;
      margin-top: 4px;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      height: 18px;
      line-height: 18px;
      text-overflow: ellipsis;
    }
  }
  .firstRow {
    // display: grid;
    // grid-template-columns: repeat(5, 1fr);
    // gap: 10px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 12px 16px;
  }

  .adv-line-2 {
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    .fiveGrid {
      display: flex;
      gap: 10px;
      &.secondLine {
        &.animation {
          animation: scroll var(--animation-duration) linear 0s infinite;
        }
      }
      &.append {
        margin-left: 10px;
      }
    }
  }
  .stopAnima {
    .animation {
      animation: none !important;
      animation-play-state: paused !important;
    }
  }
  // 竖方块
  .verticalCube {
    --size-width: 100px;
    --size-height: 150px;
    .fiveGrid {
      gap: 5px;
    }
    .rectAdvBox {
      .rectName {
        font-size: 14px;
        text-align: left;
      }
    }
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 10px));
  }
}
.swipe-box {
  width: 100%;
  // height: 143px;
  max-height: 180px;
  margin-bottom: 6px;
}
:deep(.van-swipe__indicators) {
  transform: translateX(0);
  left: unset;
  right: 9px;
  .van-swipe__indicator {
    width: 6px;
    height: 6px;
    border-radius: 3px;
  }
  .van-swipe__indicator--active {
    width: 12px;
    height: 6px;
  }
}
</style>
